import { concat, union } from 'lodash'
import { LS_SPORT_ID, SPORT_ID } from 'adv-protocol/src/GameCommon'

export enum GAME_CATEGORY {
  CROSS = 0,
  WIN_DRAW_LOSE = 1,
  HANDICAP = 2,
  LIVE = 3,
  SPECIAL = 4,
  CASINO = 5,
  BACCARAT = 6,
}

export enum GAME_TYPE {
  CROSS = 'cross',
  WAY = 'way',
  UO = 'uo',
  SPECIAL = 'special',
  LIVE = 'live',
  CASINO = 'casino',
  BACCARAT = 'baccarat',
  MIX = 'mix',
}

export enum UNIFIED_OUTCOME_TYPE {
  THREE_WAY_HOME = '1',
  THREE_WAY_DRAW = '2',
  THREE_WAY_AWAY = '3',
  TWO_WAY_HOME = '4',
  TWO_WAY_AWAY = '5',
  HANDICAP_HOME = '1714',
  HANDICAP_AWAY = '1715',
  TOTAL_UNDER = '13',
  TOTAL_OVER = '12',
}

export enum LS_OUTCOME_TYPE {
  THREE_WAY_HOME = '5',
  THREE_WAY_DRAW = '6',
  THREE_WAY_AWAY = '7',
  TWO_WAY_HOME = '5',
  TWO_WAY_AWAY = '7',
  HANDICAP_HOME = '3',
  HANDICAP_AWAY = '4',
  TOTAL_UNDER = '1',
  TOTAL_OVER = '2',
}

export const UNIFIED_OUTCOMES_WAY = ['1', '2', '3', '4', '5']
export const UNIFIED_OUTCOMES_HANDICAP = ['1714', '1715']
export const UNIFIED_OUTCOMES_UNDEROVER = ['13', '12'] // 13:Under, 12:Over
export const UNIFIED_REGULAR_OUTCOMES = concat(
  UNIFIED_OUTCOMES_WAY,
  UNIFIED_OUTCOMES_HANDICAP,
  UNIFIED_OUTCOMES_UNDEROVER,
)

export const LS_OUTCOMES_WAY = ['5', '6', '7']
export const LS_OUTCOMES_HANDICAP = ['3', '4']
export const LS_OUTCOMES_UNDEROVER = ['1', '2'] // 1:Under, 2:Over
export const LS_REGULAR_OUTCOMES = concat(
  LS_OUTCOMES_WAY,
  LS_OUTCOMES_HANDICAP,
  LS_OUTCOMES_UNDEROVER,
)

export const UNIFIED_REGULAR_ODDS_2_WAY = ['219', '251', '186']
export const UNIFIED_REGULAR_ODDS_3_WAY = ['1']
// 승무패, 승패(연장포함-농구), 승패(연장포함-야구), 승패(배구)
export const UNIFIED_REGULAR_ODDS_WAY = concat(UNIFIED_REGULAR_ODDS_3_WAY, UNIFIED_REGULAR_ODDS_2_WAY)
// 핸디캡, 핸디캡(오버타임포함), 포인트 핸디캡, 핸디캡(연장전포함-야구)
export const UNIFIED_REGULAR_ODDS_HANDICAP = ['16', '223', '237', '256']
// 언더오버, 언더오버(연장포함), 언더오버(포인트), 언더오버(연장포함-야구)
export const UNIFIED_REGULAR_ODDS_UNDEROVER = ['18', '225', '238', '258']

// 승무패, 승패, 승패(연장포함)
export const LS_REGULAR_ODDS_WAY = ['1', '52', '226']
// 아시안핸디캡, 핸디캡(연장포함), 배구 점수핸디캡(1558)
export const LS_REGULAR_ODDS_HANDICAP = ['3', '342', '1558']
// 언더오버, 언더오버(연장포함)
export const LS_REGULAR_ODDS_UNDEROVER = ['2', '28', '835']


export const UNIFIED_IRREGULAR_ODDS_HANDICAP = [
  '14', '66', '88', '117', '165', '176', '187', '188',
  '203', '231', '246', '275', '303', '309',
  '410', '460', '477', '486', '744', '746',
]
export const UNIFIED_SEPCIAL_ODDS_HANDICAP = ['30005', '30010', '30013']

export const LS_IRREGULAR_ODDS_HANDICAP = [
  '13', '53', '61', '64', '65', '66', '67', '68', '95', '201', '250', '281',
  '283', '307', '386', '407', '408', '433', '447', '448', '449', '450', '467',
  '468', '526', '555', '757', '866', '935', '958', '982', '983', '1083', '1149',
  '1150', '1151', '1152', '1153', '1215', '1227', '1228', '1231', '1232', '1240',
  '1241', '1248', '1268', '1270', '1318', '1319', '1320', '1321', '1322', '1323',
  '1367', '1368', '1369', '1370', '1371', '1372', '1373', '1374', '1375', '1376',
  '1377', '1378', '1379', '1380', '1381', '1382', '1383', '1384', '1385', '1386',
  '1387', '1388', '1389', '1390', '1391', '1394', '1408', '1439', '1541',
  '1579', '1580', '1581', '1609', '1610', '1611', '1620', '1622', '1691', '1692',
  '1693', '1694', '1835', '1877', '1878', '1922', '1963', '1967', '2028', '2032',
  '2035', '2039', '2040', '2045', '2049', '2052', '2056', '2057', '2063', '2095',
  '2096', '2097', '2102', '2126', '2164', '2168', '2191', '2206', '2218', '2228',
  '2259', '2260', '2285', '2286', '2334', '2337', '2342', '2348', '2389', '2391',
  '2393', '2395', '2397', '2408', '2409', '2410', '2411', '2457', '2458', '2459',
  '2460', '2461', '2462', '2470', '2471', '2699',
]
export const LS_IRREGULAR_ODDS_ZERO_SPECIFIERS_ALLOW = [
  '6', '9', '13', '61', '100', '217', '305', '317', '318', '319', '320', '322',
  '386', '394', '395', '431', '433', '880', '935', '1691', '1692', '1693', '1694',
]
export const LS_IRREGULAR_ODDS_UNDER_OVER = [
  '21', '29', '30', '31', '45', '46', '47', '48', '77',
  '101', '102', '129', '132', '133', '135', '136', '153', '154', '155', '156', '157', '158', '162', '165',
  '166', '180', '181', '182', '183', '184', '185', '186', '187', '214', '220', '221', '222', '223', '236',
  '287', '288', '305', '308', '309', '317', '318', '319', '320', '321', '322', '337', '352', '353', '354',
  '355', '401', '402', '403', '404', '405', '414', '416', '417', '418', '427', '430', '431', '436', '437',
  '466', '469', '475', '476', '477', '478', '523', '525', '553', '557', '558', '559', '564', '577', '578',
  '755', '756', '758', '759', '760', '763', '766', '767', '836', '839', '842', '843', '846', '848',
  '849', '850', '853', '879', '880', '914', '915', '916', '917', '918', '919', '920', '921', '922', '923',
  '927', '928', '929', '930', '936', '938', '939', '947', '948', '950', '960', '961', '962', '963', '964',
  '965', '989', '990', '991',
  '1001', '1002', '1003', '1004', '1005', '1006', '1007', '1008', '1009', '1051', '1052', '1053', '1054',
  '1055', '1061', '1069', '1070', '1071', '1072', '1073', '1074', '1075', '1076', '1077', '1078', '1079',
  '1080', '1085', '1086', '1087', '1088', '1089', '1090', '1091', '1092', '1093', '1096', '1098', '1099',
  '1101', '1103', '1104', '1105', '1106', '1112', '1115', '1120', '1121', '1122', '1128', '1129', '1130',
  '1131', '1132', '1133', '1134', '1135', '1136', '1139', '1141', '1142', '1147', '1148', '1154', '1155',
  '1156', '1161', '1162', '1163', '1164', '1185', '1186', '1187', '1188', '1189', '1193', '1194', '1195',
  '1196', '1197', '1198', '1199', '1200', '1201', '1202', '1203', '1204', '1205', '1206', '1207', '1208',
  '1209', '1210', '1213', '1214', '1216', '1217', '1218', '1219', '1222', '1223', '1226', '1229', '1230',
  '1233', '1236', '1237', '1242', '1249', '1271', '1272', '1274', '1275', '1276', '1277', '1278', '1279',
  '1280', '1281', '1282', '1283', '1284', '1285', '1286', '1287', '1291', '1292', '1293', '1294', '1295',
  '1302', '1303', '1304', '1306', '1307', '1324', '1325', '1341', '1342', '1343', '1344', '1345', '1346',
  '1347', '1348', '1349', '1350', '1351', '1352', '1353', '1354', '1355', '1356', '1357', '1358', '1359',
  '1360', '1361', '1362', '1363', '1364', '1365', '1366', '1395', '1396', '1397', '1399', '1400', '1403',
  '1411', '1412', '1413', '1414', '1416', '1417', '1418', '1419', '1420', '1421', '1424', '1427', '1434',
  '1435', '1436', '1437', '1438', '1440', '1441', '1442', '1445', '1446', '1457', '1459', '1461', '1463',
  '1465', '1467', '1469', '1471', '1473', '1475', '1477', '1479', '1481', '1483', '1485', '1487', '1489',
  '1491', '1493', '1495', '1504', '1505', '1506', '1507', '1523', '1524', '1525', '1526', '1527', '1528',
  '1533', '1534', '1536', '1537', '1538', '1540', '1552', '1555', '1556', '1562', '1591', '1624', '1625',
  '1626', '1627', '1628', '1629', '1631', '1635', '1636', '1637', '1671', '1672', '1702', '1703', '1708',
  '1709', '1710', '1711', '1714', '1715', '1723', '1724', '1725', '1726', '1727', '1762', '1776', '1777',
  '1778', '1780', '1781', '1782', '1783', '1784', '1787', '1788', '1789', '1790', '1791', '1792', '1795',
  '1802', '1803', '1806', '1807', '1808', '1809', '1810', '1812', '1825', '1826', '1827', '1828', '1829',
  '1830', '1832', '1833', '1834', '1852', '1853', '1854', '1855', '1856', '1857', '1858', '1865', '1866',
  '1870', '1890', '1901', '1904', '1905', '1910', '1916', '1917', '1919', '1920', '1922', '1926', '1927',
  '1928', '1929', '1930', '1931', '1932', '1933', '1934', '1940', '1941', '1942', '1943', '1944', '1957',
  '1958', '1959', '1960', '1961', '1962', '1968', '1969', '1973', '1975', '1976', '1977', '1978', '1979',
  '1980', '1981', '1982', '1983', '1984', '1985', '1986', '1987', '1988', '1989', '1990', '1991', '1992',
  '1993', '1994', '1995', '1996', '1997', '1998', '2003', '2005', '2006', '2007', '2017', '2019', '2021',
  '2026', '2029', '2030', '2031', '2033', '2036', '2037', '2038', '2043', '2046', '2047', '2048', '2050',
  '2053', '2054', '2055', '2060', '2091', '2092', '2093', '2094', '2098', '2099', '2100', '2101', '2140',
  '2148', '2149', '2152', '2153', '2157', '2158', '2165', '2170', '2177', '2178', '2179', '2180', '2192',
  '2208', '2209', '2221', '2222', '2223', '2224', '2225', '2247', '2248', '2266', '2267', '2270', '2271',
  '2272', '2280', '2281', '2284', '2289', '2290', '2296', '2297', '2299', '2300', '2305', '2306', '2307',
  '2308', '2313', '2314', '2339', '2340', '2343', '2344', '2345', '2346', '2349', '2350', '2351', '2352',
  '2364', '2365', '2375', '2376', '2377', '2378', '2379', '2380', '2381', '2399', '2400', '2401', '2404',
  '2405', '2430', '2431', '2432', '2433', '2434', '2435', '2439', '2442', '2443', '2444', '2445', '2446',
  '2447', '2449', '2450', '2466', '2467', '2468', '2469', '2473', '2474', '2475', '2476', '2493', '2539',
  '2541', '2542', '2543', '2568', '2581', '2582', '2583', '2599', '2601', '2602', '2603', '2604', '2605',
  '2606', '2607', '2608', '2609', '2610', '2611', '2612', '2613', '2614', '2615', '2616', '2617', '2618',
  '2619', '2620', '2621', '2622', '2623', '2644', '2645', '2650', '2675', '2676', '2677', '2692', '2694',
]
export const LS_SPECIAL_ODDS_HANDICAP = []

export const UNIFIED_TOTAL_ODDS_HANDICAP = concat(
  UNIFIED_REGULAR_ODDS_HANDICAP,
  UNIFIED_IRREGULAR_ODDS_HANDICAP,
  UNIFIED_SEPCIAL_ODDS_HANDICAP,
)

export const LS_TOTAL_ODDS_HANDICAP = concat(
  LS_REGULAR_ODDS_HANDICAP,
  LS_IRREGULAR_ODDS_HANDICAP,
  LS_SPECIAL_ODDS_HANDICAP,
)

export const LS_TOTAL_ODDS_UNDER_OVER = concat(
  LS_REGULAR_ODDS_UNDEROVER,
  LS_IRREGULAR_ODDS_UNDER_OVER,
)

export const UNIFIED_REGULAR_ODDS = union(
  UNIFIED_REGULAR_ODDS_WAY,
  UNIFIED_REGULAR_ODDS_HANDICAP,
  UNIFIED_REGULAR_ODDS_UNDEROVER,
)

export const LS_REGULAR_ODDS = union(
  LS_REGULAR_ODDS_WAY,
  LS_REGULAR_ODDS_HANDICAP,
  LS_REGULAR_ODDS_UNDEROVER,
)

export const UNIFIED_REGULAR_ODDS_ORDER = concat(
  UNIFIED_REGULAR_ODDS_WAY,
  UNIFIED_REGULAR_ODDS_HANDICAP,
  UNIFIED_REGULAR_ODDS_UNDEROVER,
)

export const GAME_TYPE_REGULAR_FILTER = {
  cross: union(UNIFIED_REGULAR_ODDS_WAY, UNIFIED_REGULAR_ODDS_HANDICAP, UNIFIED_REGULAR_ODDS_UNDEROVER),
  way: union(UNIFIED_REGULAR_ODDS_WAY, []),
  uo: union(UNIFIED_REGULAR_ODDS_HANDICAP, UNIFIED_REGULAR_ODDS_UNDEROVER),
  live: UNIFIED_REGULAR_ODDS_WAY,
}

export const LS_GAME_TYPE_REGULAR_FILTER = {
  cross: union(LS_REGULAR_ODDS_WAY, LS_REGULAR_ODDS_HANDICAP, LS_REGULAR_ODDS_UNDEROVER),
  way: union(LS_REGULAR_ODDS_WAY, []),
  uo: union(LS_REGULAR_ODDS_HANDICAP, LS_REGULAR_ODDS_UNDEROVER),
  live: LS_REGULAR_ODDS_WAY,
}

export const GAME_TYPE_REGULAR_FILTER_TYPE = {
  [GAME_CATEGORY.CROSS]: union(UNIFIED_REGULAR_ODDS_WAY, UNIFIED_REGULAR_ODDS_HANDICAP, UNIFIED_REGULAR_ODDS_UNDEROVER),
  [GAME_CATEGORY.WIN_DRAW_LOSE]: UNIFIED_REGULAR_ODDS_WAY,
  [GAME_CATEGORY.HANDICAP]: union(UNIFIED_REGULAR_ODDS_HANDICAP, UNIFIED_REGULAR_ODDS_UNDEROVER),
  [GAME_CATEGORY.LIVE]: UNIFIED_REGULAR_ODDS_WAY,
}

export const LS_GAME_TYPE_REGULAR_FILTER_TYPE = {
  [GAME_CATEGORY.CROSS]: union(LS_REGULAR_ODDS_WAY, LS_REGULAR_ODDS_HANDICAP, LS_REGULAR_ODDS_UNDEROVER),
  [GAME_CATEGORY.WIN_DRAW_LOSE]: LS_REGULAR_ODDS_WAY,
  [GAME_CATEGORY.HANDICAP]: union(LS_REGULAR_ODDS_HANDICAP, LS_REGULAR_ODDS_UNDEROVER),
  [GAME_CATEGORY.LIVE]: LS_REGULAR_ODDS_WAY,
}

export const LEGACY_REGULAR_OUTCOMES = ['1', 'X', '2', 'Under', 'Over']
export const LEGACY_REGULAR_ODDS_WAY = ['10', '20']
export const LEGACY_REGUALR_ODDS_HANDICAP = ['51', '228']
export const LEGACY_REGULAR_ODDS_UNDEROVER = ['56', '60', '229']
export const LEGACY_REGULAR_ODDS_LIVE = ['-1', '10', '37', '102']

export const LEGACY_REGULAR_ODDS = union(
  LEGACY_REGULAR_ODDS_WAY,
  LEGACY_REGUALR_ODDS_HANDICAP,
  LEGACY_REGULAR_ODDS_UNDEROVER,
)

export const LegacyCategoryOddsType = {
  [GAME_CATEGORY.CROSS]: ['10', '20', '51', '56', '60', '228', '229'],
  [GAME_CATEGORY.WIN_DRAW_LOSE]: ['10', '20'],
  [GAME_CATEGORY.HANDICAP]: ['51', '56', '60', '228', '229'],
  [GAME_CATEGORY.LIVE]: ['-1', '10', '37', '102'],
}

// 1:축구, 2:농구, 3:야구, 23:배구, 4:아이스하키
export const MAJOR_SPORT_IDS = [
  SPORT_ID.SOCCER,
  SPORT_ID.BASKETBALL,
  SPORT_ID.BASEBALL,
  SPORT_ID.VOLLEYBALL,
  SPORT_ID.ICE_HOCKEY,
]

// 타임라인 팝업이 출력 되는 종목
// 1:축구, 2:농구, 3:야구, 23:배구, 4:아이스하키, 20:탁구, 5:테니스, 6: 핸드볼
export const TIMELINE_POPUP_ENABLED_SPORT_IDS = [
  SPORT_ID.SOCCER,
  SPORT_ID.BASKETBALL,
  SPORT_ID.BASEBALL,
  SPORT_ID.VOLLEYBALL,
  SPORT_ID.ICE_HOCKEY,
  SPORT_ID.TABLE_TENNIS,
  SPORT_ID.TENNIS,
  SPORT_ID.HANDBALL,
]

// 6046:축구, 48242:농구, 154914:야구, 154830:배구, 35232:아이스하키
export const LS_MAJOR_SPORT_IDS = [
  LS_SPORT_ID.FOOTBALL,
  LS_SPORT_ID.BASKETBALL,
  LS_SPORT_ID.BASEBALL,
  LS_SPORT_ID.VOLLEYBALL,
  LS_SPORT_ID.ICE_HOCKEY,
]

// market 은 승무패, 핸디캡, 언더오버만 우선.
export const SKIP_SPECIFIER_POINTS = [0, 25, 75]
export const SKIP_IRREGULAR_SPECIFIER_POINTS = [25, 75]
export const ALLOW_SUB_MARKET_SPECIFIER_POINTS = [50]

export enum DETAIL_OUTCOME_TYPE {
  DETAIL_UNDER = '13',      // 언더
  LS_DETAIL_UNDER = '1', // LS 언더
}

// 1~5회 승무패, 1~5회 핸디캡, 1~5회 언더오버, 1~5이닝 홈팀 언더오버, 1~5이닝 원정팀
export const EXCEPTIONAL_BASEBALL_DEACTIVATE_MARKET_IDS = ['274', '275', '276', '277', '278']
